import React from 'react'
import { Select } from 'components/forms'
import { Message } from 'react-hook-form'
// @ts-ignore
import { GIFT_GIVER_RELATIONSHIPS } from 'shared/constants'
import { map } from 'lodash'

export interface RelationshipToBabySelectorProps {
  className?: string
  inputRef?: any
  error?: Message
  selectedOption?: string
}

const RelationshipToBabySelector = ({
  className,
  inputRef,
  error,
  selectedOption,
}: RelationshipToBabySelectorProps) => {
  return (
    <Select
      className={className}
      label="Your Relationship to Baby"
      name="relationshipToBaby"
      inputRef={inputRef}
      error={error}
    >
      <option />
      {map(GIFT_GIVER_RELATIONSHIPS, (label, key) => (
        <option key={key} value={key} selected={selectedOption == key}>
          {label}
        </option>
      ))}
    </Select>
  )
}

export default RelationshipToBabySelector
